module.exports = __webpack_public_path__ + "img/maintenance.aac22d7a.svg";